module.exports = __webpack_public_path__ + "static/media/api.921c978d.svg";